// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { XngStickyWrapper } from "@rpsc/App/Components/XngSticky/XngSticky";
import { containerStyles as OnePageCheckoutStyles } from "@rpsc/Overrides/Widgets/OnePageCheckout/OnePageCheckoutPageContainer";
import { containerStyles } from "@rpsc/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationPageContainer";
import { avoidBreakInsidePrintElement, mergeWithCss, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

containerStyles.container = {
    ...OnePageCheckoutStyles.container,
};

containerStyles.leftSection = {
    ...OnePageCheckoutStyles.leftSection,
};

containerStyles.rightSection = {
    css: css`
        ${XngStickyWrapper} {
            > div {
                display: flex;
                flex-direction: column;
                gap: 24px;
                @media print {
                    display: block;
                    > div {
                        ${avoidBreakInsidePrintElement}
                    }
                    & > div:not(:last-child) {
                        margin-bottom: 24px;
                    }
                }
            }
        }
    `,
};

containerStyles.leftItemsSection = {
    ...mergeWithCss(OnePageCheckoutStyles.leftItemsSection, {
        css: css`
            @media Print {
                gap: 0;
                & > div:not(:last-child) {
                    margin-bottom: 24px;
                }
            }
        `,
    }),
};

containerStyles.paymentContainer = {
    ...OnePageCheckoutStyles.paymentContainer,
};

containerStyles.shippingContainer = {
    ...OnePageCheckoutStyles.shippingContainer,
};

containerStyles.successMsgWideScreen = {
    css: css`
        display: block;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

containerStyles.successMsg = {
    css: css`
        display: none;
        h1 {
            margin-bottom: 0;
        }
        ${xScreen("lte", "md")} {
            display: block;
        }
    `,
};
